import {
  type McpServerSpec,
  propagationHint,
} from "@p0security/shared/types/agentic/mcp";

import { AwsIconUrl } from "./icon.ts";

/** LiquidJS template rendering the IAM role ARN the gateway assumes for an
 * AWS policy grant
 */
// Indexing the first delegate is safe
// because the agentic lifecycles (`delegatingPolicyLifecycle`,
// `delegatingResourceLifecycle`) each emit exactly one `aws-oidc` delegate.
const AWS_MCP_ROLE_ARN_TEMPLATE =
  "{{ request.delegation[0].request.generated.arn }}";

export const awsMcp: McpServerSpec = {
  type: "container",
  label: "AWS CLI",
  iconUrl: AwsIconUrl,
  credential: {
    type: "wif",
    csp: "aws",
    parameter: "generated.name",
    awsRoleArn: AWS_MCP_ROLE_ARN_TEMPLATE,
  },
  authorization: "upstream",
  transport: "stdio",
  container: {
    command: [],
    args: [],
    envs: {
      // credential is the gateway's AwsTempCreds shape (accessKeyId /
      // secretAccessKey / sessionToken) — these must match its field names,
      // not the AWS CLI's own env var names.
      AWS_ACCESS_KEY_ID: "{{credential.accessKeyId}}",
      AWS_SECRET_ACCESS_KEY: "{{credential.secretAccessKey}}",
      AWS_SESSION_TOKEN: "{{credential.sessionToken}}",
    },
    image: { image: "mcp/aws-api-mcp-server" },
  },
  tools: { type: "docker", id: "aws-api" },
  access: {
    prompt: `Request AWS access by calling with argv:

  [...<arns>, "--account", <account>, "--reason", <reason>]

where arguments are:

  - arns: ARN(s) of customer or built-in AWS policies required to perform the AWS API calls
    you are making (e.g. 'arn:aws:iam::aws:policy/AmazonS3ReadOnlyAccess'); pass multiple policy
    ARNs as separate arguments
  - account: AWS account alias or account number
  - reason: Business justification for the requested access
`,
    prefixArgs: ["aws", "policy"],
    propagationHint: propagationHint({
      resource: "AWS",
      normalWait: "less than 10 seconds",
      maxWait: "30 seconds",
      pollInterval: "5 seconds",
    }),
  },
  list: {
    fields: {
      account: {
        description: "AWS account alias / number",
        required: [],
      },
      arns: {
        description: "Available policy ARN",
        required: ["account"],
      },
    },
    prefixArgs: ["aws", "policy"],
  },
  location: {
    key: "account",
    description: "AWS account where calls are made",
  },
};
